// extracted by mini-css-extract-plugin
export var active = "Pagination-module--active--580b5";
export var hide = "Pagination-module--hide--22a7e";
export var item = "Pagination-module--item--a5792";
export var root = "Pagination-module--root--80283";